import { useEffect, useRef } from 'react';

const useIntersectionObserver = (callback, options) => {
	const ref = useRef();

	useEffect(() => {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => callback(entry));
		}, options);

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => {
			if (ref?.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
				observer.unobserve(ref?.current);
			}
		};
	}, [callback, options]);

	return ref;
};

export default useIntersectionObserver;
